const MOBILE_PATTERNS = {
  // Ukrainian mobile network destination codes.
  UA: /^\+380(?:39|50|63|66|67|68|73|89|91|92|93|94|95|96|97|98|99)\d{7}$/,
  // Czech mobile numbers use nine national digits and start with 6 or 7.
  CZ: /^\+420[67]\d{8}$/
};

export const normalizePhoneNumber = value => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (raw.startsWith('00')) return `+${digits.slice(2)}`;
  return `+${digits}`;
};

export const phoneCountry = phoneNumber => {
  const normalized = normalizePhoneNumber(phoneNumber);
  if (normalized.startsWith('+380')) return 'UA';
  if (normalized.startsWith('+420')) return 'CZ';
  if (normalized.startsWith('+1')) return 'US';
  return 'OTH';
};

export const validateSmsPhoneNumber = value => {
  const phoneNumber = normalizePhoneNumber(value);
  if (!/^\+[1-9]\d{7,14}$/.test(phoneNumber)) {
    return { valid: false, phoneNumber, errorKey: 'InvalidPhoneNumberFormat' };
  }

  const country = phoneCountry(phoneNumber);
  const mobilePattern = MOBILE_PATTERNS[country];
  if (mobilePattern && !mobilePattern.test(phoneNumber)) {
    return { valid: false, phoneNumber, errorKey: 'SmsMobileNumberRequired' };
  }

  return { valid: true, phoneNumber, errorKey: null };
};
